<template>
  <Meta
    name="og:image"
    :content="`https://boostingmarket.com/images/og-images/work-with-us-og.png?v=11`"
  />
  <Meta
    name="twitter:image"
    :content="`https://boostingmarket.com/images/og-images/work-with-us-og.png?v=11`"
  />

  <div class="d-flex-column justify-start align-start gap-30">
    <WorkWithUsHero />
    <StartSelling />
    <WhyUs />
    <AverageSalary />
    <TrustedBy />
    <OpenPositions />
    <WorkWithUsFaq />
    <!-- WHY US -->
  </div>
</template>

<script setup>
import WorkWithUsHero from "~/components/banners/WorkWithUsHero.vue";
import StartSelling from "~/components/work-with-us/StartSelling.vue";
import WhyUs from "~/components/work-with-us/WhyUs.vue";
import AverageSalary from "~/components/work-with-us/AverageSalary.vue";
import TrustedBy from "~/components/work-with-us/TrustedBy.vue";
import WorkWithUsFaq from "~/components/sections/WorkWithUsFaq.vue";
import OpenPositions from "~/components/work-with-us/OpenPositions.vue";

const router = useRouter();
const route = router.currentRoute;
// HOOKS

// REACTIVE VARIABLES
// const offers = computed(() => {
//   return [
//     {
//       title: t("work_with_us.why_title_1"),
//       desription: t("work_with_us.why_description_1"),
//       image: "/images/work-with-us/booster_benefit_1.webp",
//     },
//     {
//       title: t("work_with_us.why_title_2"),
//       desription: t("work_with_us.why_description_2"),
//       image: "/images/work-with-us/booster_benefit_2.webp",
//     },
//     {
//       title: t("work_with_us.why_title_3"),
//       desription: t("work_with_us.why_description_3"),
//       image: "/images/work-with-us/booster_benefit_3.webp",
//     },
//   ];
// });

// const { games } = useGameComposable();
addCanonicalLink(route.value.fullPath);

onNuxtReady(() => {});
</script>
